export interface ICards {
  cardName: string;
  cardNumber: string;
  defaultCard: number;
  expiryDate: string;
  token: string;
}


export interface PaymentData {
  msgId: string;
  amount: string;
  description?: string;
  transactionReference?: string;
  saleId: string;
  email: string;
  saveCreditCard?: boolean;
  memberRefId?: string;
  ticketlessFB?: boolean;
  movieId?: string;
  googleApplePay?: boolean;
  id?: string;
}

export interface PaymentResponseStripe {
  status: boolean;
  message?: string;
}

export interface PaymentResponse {
  status: boolean;
  responseDesc?: string;
  responseCode?: string;
  message?: string;
  amount?: string;
  txnID?: string;
  authID?: string;
  cardNumber?: string;
  transactionReference?: string;
}

export interface MovieTransaction {
  countryId: string;
  saleId: string;
  requestType?: string;
}

export interface EncryptionKeyData {
  key: string;
}

export interface EncryptionKeyResponse {
  statusCode: number;
  data: EncryptionKeyData;
}

export interface ICardDetails {
  expirymonth?: string;
  expiryyear?: string;
  cardNumber?: string;
  cardHolderName?: string;
  cvv?: string;
  expiryDate?: string;
}
export interface IStripePaymentStatus {
  status: boolean;
  error?: string;
  cardDetails?: ICardDetails;
  paymentIntentId?: string;
}

export interface IConcessionData {
  Concession_sale_id: string,
  Description: string,
  Extra: string,
  Id: number,
  Item_id: number,
  Price: number,
  Quantity: number,
  Ticket_sale_id: string,
  collect_type: string,
  collection_time: string,
  order_ready_time: string,
  refundstatus: string,
  status: string,
  checked?: boolean,
  LineNumber: any
}

export interface IConcessionFormatData {
  ItemId: number,
  RowId: number,
  Price: number
}
export interface ITicketData {
  Id: number,
  Seat_number: string,
  Ticket_price: number,
  Ticket_qnty: number,
  Ticket_type: string,
  Tsd_id: number,
  refundstatus: string,
  checked?: boolean,
  package_seat: string,
  sequenceNumber?: number
}

export interface ITicketFormatData {
  SeatRowId?: string, 
  SeatNumber?: string, 
  RowId: number,
  Ticket_price: number
}

export interface ICheckRefund {
  bookingFee: string,
  concessionAmount: number,
  message: string,
  status: boolean,
  ticketAmount: string,
  totalAmount: string,
  transactionRefNo: string,
  txnId: string,
  email: string,
  ticketConfirmationNumber: string,
  concessionData?: IConcessionData[],
  ticketData?: ITicketData[]
}

export enum PAYMENT_TYPE {
  CARD = "card",
  APPLE_PAY = "applePay",
  GIFT_CARD = "giftcard",
  GOOGLE_PAY = "googlePay",
  NSW_VOUCHER = "nswVoucher",
  PAY_WITH_POINTS = "paywithpoints"
}

export interface ISocialShare {
  Id: string,
  Plat_Form: string,
  Session_Seat_Sharing_Description: string,
  Session_Seat_Sharing_title: string,
  Session_Seat_Sharing_url_link: string,
  Session_Sharing_Description: string,
  Session_Sharing_title: string,
  Session_Sharing_url_link: string,
  brandId: string,
  countryId: string,
  image1: string,
  image2: string,
  image3: string,
  image4: string,
  online: number,
  uniqueKey: string
}

export interface ILoyaltyPoints {
  balanceTypeId: number,
  balanceTypeName: string,
  pointsRemaining: number,
  pointsRemainingInCents: number,
  pointsUsed: number
}

export interface MailLibraryPayLoad {
  id?: string | number;
  countryId?: string;
  templateName?: string;
  swappedTicket?: boolean;
}